const NAMESPACE = "envelopeFormElement";

const KEYS = {
    noEnvelopeDefinitionSelectedError: "noEnvelopeDefinitionSelectedError",
    noDocumentsResendableMsg: "noDocumentsResendableMsg",
    downloadCombinedDocumentButton: "downloadCombinedDocumentButton",
    downloadCertificateOfCompletionButton: "downloadCertificateOfCompletionButton",
    signAndUploadTab: "signAndUploadTab",
    eSignTab: "eSignTab",
    recipientsAreIncompleteError: "recipientsAreIncompleteError",
    recipientsAreIncompleteAndMissingAttachmentsError: "recipientsAreIncompleteAndMissingAttachmentsError",
    missingAttachmentsError: "missingAttachmentsError",
    missingRequiredAttachmentItemText: "missingRequiredAttachmentItemText",
    missingOptionalAttachmentItemText: "missingOptionalAttachmentItemText",
    documentsAreCompleteAlert: "documentsAreCompleteAlert",
    discardEnvelopeModalHeader: "discardEnvelopeModalHeader",
    discardEnvelopeModalContent: "discardEnvelopeModalContent",
    startingOverLoadingText: "startingOverLoadingText",
    resendingNotificationsLoadingText: "resendingNotificationsLoadingText",
    requestingSignaturesLoadingText: "requestingSignaturesLoadingText",
    voidingSignaturesLoadingText: "voidingSignaturesLoadingText",
    discardingEnvelopeLoadingText: "discardingEnvelopeLoadingText",
    downloadingLoadingText: "downloadingLoadingText",
    creatingLoadingText: "creatingLoadingText",
    completingEnvelopeLoadingText: "completingEnvelopeLoadingText",
    generatingDocumentLoadingText: "generatingDocumentLoadingText",
    downloadPreviewButton: "downloadPreviewButton",
    downloadButton: "downloadButton",
    itemsColumnHeader: "itemsColumnHeader",
    actionsColumnHeader: "actionsColumnHeader",
    recipientsColumnHeader: "recipientsColumnHeader",
    statusColumnHeader: "statusColumnHeader",
    beginWetSignButton: "beginWetSignButton",
    completedBadgeText: "completedBadgeText",
    completeButton: "completeButton",
    discardButton: "discardButton",
    startOverButton: "startOverButton",
    requestESignaturesButton: "requestESignaturesButton",
    manageRequestButton: "manageRequestButton",
    closeDialogButton: "closeDialogButton",
    generateButton: "generateButton",
    uploadWetSignDocumentAltText: "uploadWetSignDocumentAltText",
    wetSignUploadedByText: "wetSignUploadedByText",
    wetSignUploadedByUnknownUser: "wetSignUploadedByUnknownUser",
    previewButton: "previewButton",
    viewButton: "viewButton",
    outOfSyncError: "outOfSyncError",
    noUserSelectedError: "noUserSelectedError",
    incompleteDataMissingOneDataField: "incompleteDataMissingOneDataField",
    incompleteDataMissingTwoDataFields: "incompleteDataMissingTwoDataFields",
    incompleteDataMissingThreeDataFields: "incompleteDataMissingThreeDataFields",
    firstNameDataField: "firstNameDataField",
    lastNameDataField: "lastNameDataField",
    emailDataField: "emailDataField",
    hideEnvelopeConfirmationHeader: "hideEnvelopeConfirmationHeader",
    hideEnvelopeConfirmationBody: "hideEnvelopeConfirmationBody",
    resendESignatureNotificationsHeader: "resendESignatureNotificationsHeader",
    resendESignaturesInfoMsg: "resendESignaturesInfoMsg",
    resendESignatureNotificationsListHeader: "resendESignatureNotificationsListHeader",
    resendESignatureNotificationsUpdatedDocumentWarning: "resendESignatureNotificationsUpdatedDocumentWarning",
    resendESignatureNotificationsUpdatedDocumentHelpMsg: "resendESignatureNotificationsUpdatedDocumentHelpMsg",
    resendLimitationsHelpMsg: "resendLimitationsHelpMsg",
    resendNotificationsButton: "resendNotificationsButton",
    hideLinkLabel: "hideLinkLabel",
    otherOptionsLinkLabel: "otherOptionsLinkLabel",
    additionalCommentsRequiredError: "additionalCommentsRequiredError",
    cancelAllDocumentsButton: "cancelAllDocumentsButton",
    cancelESignaturesHeader: "cancelESignaturesHeader",
    selectCancelReasonLabel: "selectCancelReasonLabel",
    anyAdditionalCommentsLabel: "anyAdditionalCommentsLabel",
    provideAdditionalDetailLabel: "provideAdditionalDetailLabel",
    cancelDeterrentResending: "cancelDeterrentResending",
    cancelDeterrentCorrectingContactInfo: "cancelDeterrentCorrectingContactInfo",
    notificationsResentBadgeText: "notificationsResentBadgeText",
    savedDocumentsHeader: "savedDocumentsHeader"
};

const MESSAGES = {
    [KEYS.noEnvelopeDefinitionSelectedError]: {
        value: "No Envelope Definition selected. Field not enabled.",
        comment: "Error message displayed when an envelope not found"
    },
    [KEYS.noDocumentsResendableMsg]: {
        value: "We are unable to resend notifications for this Envelope at this time. You must wait {bufferMinutes} minutes between attempts to resend eSignature notifications.",
        comment: "Message that displays to the user if no notifications can be resent"
    },
    [KEYS.downloadCombinedDocumentButton]: {
        value: "Download Combined Document",
        comment: "Button to download the combined document"
    },
    [KEYS.downloadCertificateOfCompletionButton]: {
        value: "Download Certificate of Completion",
        comment: "Button to download the certificate of completion"
    },
    [KEYS.signAndUploadTab]: {
        value: "Sign and Upload",
        comment: "Tab header to sign and upload a document"
    },
    [KEYS.eSignTab]: {
        value: "eSign",
        comment: "Tab header to electronically sign a document"
    },
    [KEYS.recipientsAreIncompleteError]: {
        value: "Recipients are incomplete",
        comment: "Error alert for when recipients are incomplete"
    },
    [KEYS.recipientsAreIncompleteAndMissingAttachmentsError]: {
        value: "Recipients are incomplete and required attachments are missing",
        comment: "Error alert for when recipients are incomplete and attachments are missing"
    },
    [KEYS.missingAttachmentsError]: {
        value: "Missing required attachments",
        comment: "Error alert for when required attachments are missing"
    },
    [KEYS.missingRequiredAttachmentItemText]: {
        value: "Missing required attachment",
        comment: "Text that indicates a required attachment-type item is missing"
    },
    [KEYS.missingOptionalAttachmentItemText]: {
        value: "No attachment uploaded",
        comment: "Text that indicates an optional attachment item is missing"
    },
    [KEYS.documentsAreCompleteAlert]: {
        value: "All documents have been uploaded, ready for envelope completion",
        comment: "Success alert for when a wet sign envelope is ready to be uploaded"
    },
    [KEYS.discardEnvelopeModalHeader]: {
        value: "Discard Envelope",
        comment: "Confirmation header when discarding envelope"
    },
    [KEYS.discardEnvelopeModalContent]: {
        value: "Are you sure you want to discard this envelope?",
        comment: "Confirmation question when discarding envelope"
    },
    [KEYS.startingOverLoadingText]: {
        value: "Starting over...",
        comment: "Loading text for when starting over an envelope"
    },
    [KEYS.resendingNotificationsLoadingText]: {
        value: "Resending notifications...",
        comment: "Loading text for when resending notifications on an envelope"
    },
    [KEYS.requestingSignaturesLoadingText]: {
        value: "Requesting...",
        comment: "Loading text for when requesting signatures"
    },
    [KEYS.voidingSignaturesLoadingText]: {
        value: "Voiding...",
        comment: "Loading text for when voiding signatures"
    },
    [KEYS.discardingEnvelopeLoadingText]: {
        value: "Discarding...",
        comment: "Loading text for discarding a wet sign envelope"
    },
    [KEYS.downloadingLoadingText]: {
        value: "Downloading...",
        comment: "Loading text for when downloading"
    },
    [KEYS.creatingLoadingText]: {
        value: "Creating...",
        comment: "Loading text for when creating a downloadable envelope item"
    },
    [KEYS.completingEnvelopeLoadingText]: {
        value: "Completing Envelope...",
        comment: "Loading text for when completing and envelope"
    },
    [KEYS.generatingDocumentLoadingText]: {
        value: "Generating...",
        comment: "Loading text for generating a wet sign document"
    },
    [KEYS.downloadPreviewButton]: {
        value: "View",
        comment: "Button for downloading the preview of an item"
    },
    [KEYS.downloadButton]: {
        value: "Download",
        comment: "Button for downloading an item"
    },
    [KEYS.itemsColumnHeader]: {
        value: "Items",
        comment: "Items column header"
    },
    [KEYS.actionsColumnHeader]: {
        value: "Actions",
        comment: "Actions column header"
    },
    [KEYS.recipientsColumnHeader]: {
        value: "Recipients",
        comment: "Recipients column header"
    },
    [KEYS.statusColumnHeader]: {
        value: "Status",
        comment: "Status column header"
    },
    [KEYS.beginWetSignButton]: {
        value: "Begin",
        comment: "Begin button for wet sign envelopes"
    },
    [KEYS.completedBadgeText]: {
        value: "Completed",
        comment: "Completed badge for wet sign envelopes"
    },
    [KEYS.completeButton]: {
        value: "Complete",
        comment: "Complete button for wet sign envelopes"
    },
    [KEYS.discardButton]: {
        value: "Discard",
        comment: "Discard button for wet sign envelopes"
    },
    [KEYS.startOverButton]: {
        value: "Start Over",
        comment: "Start Over button"
    },
    [KEYS.requestESignaturesButton]: {
        value: "Request eSignatures",
        comment: "Request eSignatures button"
    },
    [KEYS.manageRequestButton]: {
        value: "Manage Request",
        comment: "Manage Request button"
    },
    [KEYS.closeDialogButton]: {
        value: "Close",
        comment: "Button for closing a dialog without action"
    },
    [KEYS.generateButton]: {
        value: "Generate",
        comment: "Button for generating a signable document"
    },
    [KEYS.uploadWetSignDocumentAltText]: {
        value: "Upload Wet Sign Document",
        comment: "Alt text to let you know what a a file uploader is for"
    },
    [KEYS.wetSignUploadedByText]: {
        value: "Uploaded by {username} on {uploadTimestamp}",
        comment: "Status text for when user uploads a wet sign item"
    },
    [KEYS.wetSignUploadedByUnknownUser]: {
        value: "Unknown User",
        comment: "Placeholder value for a document uploaded by an unknown (possibly deleted) user"
    },
    [KEYS.previewButton]: {
        value: "Preview",
        comment: "Preview button for wetsign items"
    },
    [KEYS.viewButton]: {
        value: "View",
        comment: "View button for wetsign items"
    },
    [KEYS.outOfSyncError]: {
        value: "Contact info has been updated",
        comment: "Error shown when contact is out of sync with the one sent"
    },
    [KEYS.noUserSelectedError]: {
        value: "Incomplete data - select a user.",
        comment: "No user selected error"
    },
    [KEYS.incompleteDataMissingOneDataField]: {
        value: "Incomplete data - missing {dataField}",
        comment: "Error shown when one data field is missing"
    },
    [KEYS.incompleteDataMissingTwoDataFields]: {
        value: "Incomplete data - missing {dataField1} and {dataField2}",
        comment: "Error shown when two data fields are missing"
    },
    [KEYS.incompleteDataMissingThreeDataFields]: {
        value: "Incomplete data - missing {dataField1}, {dataField2}, and {dataField3}",
        comment: "Error shown when three data fields are missing"
    },
    [KEYS.firstNameDataField]: {
        value: "first name",
        comment: "First name data field that may be missing"
    },
    [KEYS.lastNameDataField]: {
        value: "last name",
        comment: "Last name data field that may be missing"
    },
    [KEYS.emailDataField]: {
        value: "email",
        comment: "Email data field that may be missing"
    },
    [KEYS.hideEnvelopeConfirmationHeader]: {
        value: "Are you sure?",
        comment: "Modal header for when an eSignature envelope is started over"
    },
    [KEYS.hideEnvelopeConfirmationBody]: {
        value: "Starting over will hide the following project attachments:",
        comment: "Modal body for starting over, followed by a list of 1 or more attachment names"
    },
    [KEYS.resendESignatureNotificationsHeader]: {
        value: "Resend eSignature Notifications",
        comment: "Modal popup header for resending notifications"
    },
    [KEYS.resendESignaturesInfoMsg]: {
        value: "If one or more eSignature recipients did not receive a notification email, select Resend Notifications. If emails continue to be undeliverable, contact your program administrator.",
        comment: "Message describing to the user what will happen if they resend notifications"
    },
    [KEYS.resendESignatureNotificationsListHeader]: {
        value: "The following recipients will be notified:",
        comment: "List header for recipients that will be resent eSignature notifications"
    },
    [KEYS.resendESignatureNotificationsUpdatedDocumentWarning]: {
        value: "Updated contact information will not be reflected in the eSignature documents.",
        comment: "Warning about the nature of resent notifications"
    },
    [KEYS.resendESignatureNotificationsUpdatedDocumentHelpMsg]: {
        value: "Updates to recipient contact information that are made after the eSignature Envelope was initially created will not be reflected in the eSignature documents. If you need the changes to be reflected in the eSignature documents, you will need to cancel the eSignature request and create a new one.",
        comment: "Help message elaborating on the limitations of correcting contact info for an existing Envelope"
    },
    [KEYS.resendLimitationsHelpMsg]: {
        value: "You must wait {minutes} minutes between attempts to resend eSignature notifications. You cannot resend notifications or correct contact info for recipients that have already signed. You cannot resend notifications for envelopes where all recipients have signed. In those cases, you must cancel the eSignature request and send a new request.",
        comment: "Help text explaining the detailed limitations on resending notifications"
    },
    [KEYS.resendNotificationsButton]: {
        value: "Resend Notifications",
        comment: "Button label for resending notifications"
    },
    [KEYS.hideLinkLabel]: {
        value: "Hide",
        comment: "Link for hiding options"
    },
    [KEYS.otherOptionsLinkLabel]: {
        value: "Other Options",
        comment: "Link for showing other options"
    },
    [KEYS.additionalCommentsRequiredError]: {
        value: "Additional comments are required",
        comment: "Error message for when addition explanation is needed for canceling envelope"
    },
    [KEYS.cancelAllDocumentsButton]: {
        value: "Cancel All Documents",
        comment: "Button for canceling an entire envelope"
    },
    [KEYS.cancelESignaturesHeader]: {
        value: "Cancel eSignature Request",
        comment: "Modal popup header for canceling notifications"
    },
    [KEYS.selectCancelReasonLabel]: {
        value: "Please select a reason for canceling the eSignature request:",
        comment: "Radio button header for selecting a reason from a list of options"
    },
    [KEYS.anyAdditionalCommentsLabel]: {
        value: "Any additional comments (will be visible in an email to recipients):",
        comment: "Input header for any additional comments about the reason you are canceling"
    },
    [KEYS.provideAdditionalDetailLabel]: {
        value: "Please provide some brief additional details (will be visible in an email to recipients):",
        comment: 'Prompt for the user to explain an "other" reason for canceling signatures.'
    },
    [KEYS.cancelDeterrentResending]: {
        value:
            "Instead of canceling, try resending notifications for your existing eSignature Envelope using the section above. " +
            "Make sure all recipients check their spam folders for an email from DocuSign System. The notification email " +
            '"From" field will show "Do Not Reply - PowerClerk Automated Notifications ' +
            '(donotreply-esign{\'@\'}cleanpower.com)." The email subject will include the text "{emailSubject}" ' +
            "and the associated project number, if available.",
        comment: "Deterrent message to discourage canceling just to resend notifications"
    },
    [KEYS.cancelDeterrentCorrectingContactInfo]: {
        value:
            "You can correct contact info for recipients who have not yet signed by updating " +
            "the relevant contact info fields on the form, returning to this dialog, and using " +
            "the Resend Notifications button above. When notifications are resent, any updated contact " +
            "info for pending recipients will be applied to the in-flight eSignature request. However, note " +
            "that updated contact information will not be reflected in the eSignature documents.",
        comment: "Deterrent message to discourage canceling to update contact info"
    },
    [KEYS.notificationsResentBadgeText]: {
        value: "Notifications Resent!",
        comment: "Text of a status badge that appears when the user has already resent notifications"
    },
    [KEYS.savedDocumentsHeader]: {
        value: "Saved Documents",
        comment: "A header for all the documents"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
